import { Vertragsoptionen } from '@ps20-frontend/frontend-models';

export enum CoverageType {
  OPSCHUTZ = 'opSchutz',
  VOLLSCHUTZ = 'vollschutz',
}

export interface VertragsoptionenTKV extends Vertragsoptionen {
  coverageType: CoverageType;
  hasWechselbaustein: boolean;
}
